import { useState } from 'react';
import { Drawer } from 'tdesign-react';

import { RichMediaValue } from '@/interface/media';
import { getMediaUrlValue } from '@/material/form-upload/change-data';


interface IPreviewProps {
  children: React.ReactNode;
  bgImage?: RichMediaValue;
}

const PreviewLayout = ({ bgImage, children }: IPreviewProps) => {
  const [visible, setVisible] = useState(false);

  const triggerClick = () => {
    setVisible(!visible);
  };

  const preivewDom = (
    <div className="preivew-phone">
      <div className="content-bg" style={{ backgroundImage: `url(${getMediaUrlValue(bgImage)})` }}>
        {children}
      </div>
    </div>
  );

  return (
    <div className="content-preview">
      {preivewDom}
      <Drawer
        visible={visible}
        onClose={triggerClick}
        header={false}
        footer={false}
        size={'400px'}
        style={{ display: 'flex', alignItems: 'center', zIndex: 2600 }}
        destroyOnClose
      >
        {preivewDom}
      </Drawer>
    </div>
  );
};

export default PreviewLayout;
